import React from "react";
import ReactTooltip from "react-tooltip";

const Search = () => {
  return (
    <div className=''>
      <div
        className='container mx-auto flex justify-center my-6 py-20 px-5 md:px-20 '
        style={{ background: "rgba(26, 32, 44,0.5)" }}
      >
        <div
          data-tip='Coming soon'
          className='bg-gray-300 w-full md:w-1/2 lg:w-3/6 rounded-r-sm rounded-l-full '
        >
          <div className='flex  justify-between flex-row'>
            <div className='bg-gray-800 py-2 px-3 text-white rounded-l-lg  font-semibold'>
              NA
            </div>
            <div className='m-1 p-2 appearance-none select-none font-semibold text-gray-900 text-sm  '>
              Search for a player..
            </div>
            <button className='m-1 p-2 text-sm bg-gray-800 rounded-lg font-semibold uppercase w-auto'>
              Search
            </button>
          </div>
        </div>
      </div>
      <ReactTooltip
        place='top'
        backgroundColor='rgb(20, 41, 61)'
        effect='float'
      />
    </div>
  );
};

export default Search;
